const ArrowLeftIcon = ({ishome, width = 20, height = 20}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 22 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.77246 5.43579L3.20829 11L8.77246 16.5641"
			stroke={ishome ? 'white' : 'currentColor'}
			stroke-width="1.375"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M18.792 11H3.36449"
			stroke={ishome ? 'white' : 'currentColor'}
			stroke-width="1.375"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
export default ArrowLeftIcon;
